export default __webpack_public_path__ + "static/media/blog.06018bd3.svg";